import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAreaOfInterest} from '../../services/projectService';
import Plot from 'react-plotly.js';

const SurfaceChart = ({data:{data,feature}}) =>{
    //const [loading, setLoading] = useState(true);
    const [error, setError] = useState(true);

  useEffect(() => {
      updateChart();
  }, [])
  const [layout, setLayout] =  useState(null)
  const updateChart = ()=> {
    const ylabel = [0];
    const ylabelValue = [];
    let pixel_size = data.pixel_size;
    data.array.forEach(d=>{
        const distance = data.array.indexOf(d) * pixel_size;
        if ((distance - ylabel.length) >=0 &&  distance >=1) {
            ylabel.push(Math.round(distance));
            ylabelValue.push(data.array.indexOf(d))
        }
    });

    const xlabel = [0];
    const xlabelValue = [];
    pixel_size = data.pixel_size;

    for (let i = 0;i<=(data.array[0].length-1); i=i+2){
        const distance = i * pixel_size;
        if ((distance - xlabel.length) >=0 &&  distance >=1
        ) {
            xlabel.push(Math.round(distance));
            xlabelValue.push(i)
        }
    }
    const chartLayaut = {
      title: {
        text:`ID: ${feature.properties.id} / NAME: ${feature.properties.name}`,
        font: {
          family: 'HelveticaNeue, monospace',
          size: 24
        },
        xref: 'paper',
        x: 0.05
      },
      scene: {
        xaxis: {
            autorange: true,
            ticktext: xlabel,
            tickvals: xlabelValue
        },
        yaxis: {
            autorange: true,
            ticktext: ylabel,
            tickvals: ylabelValue
        }
    },
    autosize: true,
    width: 1200,
    height: 700,
  }
    setLayout(chartLayaut);

};
  return (
    <div>
      <Plot
        data={[{z:  data.array.reverse(),type: "surface"}]}
        layout={layout}
      />
    </div>
  );

  
  
}

export default SurfaceChart;